import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { Select, DatePicker } from "antd";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineEye } from "react-icons/ai";
import { AiOutlineEdit } from "react-icons/ai";
import { BsCheckCircle } from "react-icons/bs";
import { IoCloseSharp } from "react-icons/io5";
import moment from "moment";
import { Image } from "react-bootstrap";
import Emp_data_pic from "../../assets/images/Emp_data_pic.png";
import SideNav from "../Sidenav";
import axiosInstance from "../../axios/axios";
import { Decrypt_Value, Encrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import CustomSuffixIcon from "../popups/CustomSuffixIcon";
import {
  PageWrapper,
  HeaderRow,
  PageTitle,
  AddButton,
  FilterRow,
  SearchWrapper,
  SearchButton,
  CardGrid,
  DietCard,
  CardTitle,
  CardDescription,
  CardDate,
  CardFooter,
  RecommendButton,
  IconGroup,
  IconBtn,
  EmptyWrapper,
  PreviewModalStyled,
  ModalLabel,
  ModalInput,
  ModalTextarea,
  FieldWrapper,
  ErrorText,
  AssignedCount,
  PreviewTitle,
  PreviewDesc,
} from "./DietRecommendation.styled";

const { RangePicker } = DatePicker;
const { Option } = Select;

const DietRecommendation = () => {
  // ─── Nav ───────────────────────────────────────────────────────────────────
  const [navData1, setNavData1] = useState("iconopen");
  const NavData1 = useSelector((state) => state.Schedule?.NavData);

  useEffect(() => {
    if (NavData1 !== "") setNavData1(NavData1);
  }, [NavData1]);

  // ─── Auth ──────────────────────────────────────────────────────────────────
  const provider = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  // ─── Diet List State ───────────────────────────────────────────────────────
  const [dietList, setDietList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [fromdt, setFromdt] = useState(
    moment().add(-7, "days").format("YYYY-MM-DD"),
  );
  const [todt, setTodt] = useState(moment().format("YYYY-MM-DD"));
  const dateFormat = localStorage.getItem("dateFormat") || "MM/DD/YYYY";
  const getDefaultWeekRange = () => ({
    fromDate: moment().add(-7, "days").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  });

  // ─── Alert State ──────────────────────────────────────────────────────────
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  // ─── Add / Edit Modal ─────────────────────────────────────────────────────
  const [showAddModal, setShowAddModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [titleVal, setTitleVal] = useState("");
  const [descVal, setDescVal] = useState("");
  const [titleErr, setTitleErr] = useState(false);
  const [descErr, setDescErr] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  // ─── Preview Modal ────────────────────────────────────────────────────────
  const [showPreview, setShowPreview] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);

  // ─── Recommend Modal ─────────────────────────────────────────────────────
  const [showRecommendModal, setShowRecommendModal] = useState(false);
  const [recommendId, setRecommendId] = useState(null);
  const [patientData, setPatientData] = useState([]);
  const [fullPatientList, setFullPatientList] = useState([]);
  const [selectPatList, setSelectPatList] = useState([]);
  const [patSearchVal, setPatSearchVal] = useState("");
  const [fornoresults, setFornoresults] = useState(["1"]);
  const [totalPat, setTotalPat] = useState("");
  const [patErr, setPatErr] = useState(false);
  const [assignLoading, setAssignLoading] = useState(false);
  const [isDateChanged, setIsDateChanged] = useState(false);

  // ─── Helpers ──────────────────────────────────────────────────────────────
  const showAlert = (msg, type = "success") => {
    setAlertMsg(msg);
    if (type === "success") {
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 1500);
    } else {
      setShowError(true);
      setTimeout(() => setShowError(false), 1500);
    }
  };

  const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // ─── Fetch Diet List ──────────────────────────────────────────────────────
  const fetchDietList = (search = "", from = fromdt, to = todt) => {
    const article = {
      search: search,
      fromDate: from,
      toDate: to,
      uid: provider,
    };

    const encrypted = Encrypt_Value(article, "vozo");

    axiosInstance
      .post("/vozo/listdiettemplate", encrypted)
      .then((response) => {
        const data = Decrypt_Value(response.data, "vozo");

        setDietList(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        setDietList([]);
      });
  };

  useEffect(() => {
    fetchDietList("", "", "");
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchDietList(searchText, "", "");
    }, 500);

    return () => clearTimeout(delay);
  }, [searchText]);

  // ─── Search ───────────────────────────────────────────────────────────────
  const handleSearch = () => {
    fetchDietList(
      searchText,
      isDateChanged ? fromdt : "",
      isDateChanged ? todt : "",
    );
  };

  const handleResetDateFilter = () => {
    const range = getDefaultWeekRange();

    setFromdt(range.fromDate);
    setTodt(range.toDate);
    setIsDateChanged(true);

    fetchDietList(searchText, range.fromDate, range.toDate);
  };

  // ─── Fetch Patients ───────────────────────────────────────────────────────
  const fetchPatients = async (search = "") => {
    await timeout(500);
    let apiUrl = "/vozo/patient/getPatientData?uid=" + provider;
    if (search.trim()) {
      apiUrl += "&name=" + encodeURIComponent(search.trim());
    }
    axiosInstance
      .get(apiUrl)
      .then((res) => {
        const decrypt_res = Decrypt_Value(res.data, "vozo");
        if (decrypt_res && decrypt_res.length > 0) {
          setPatientData(decrypt_res[0]);
          setFullPatientList(decrypt_res[0]);
          setFornoresults(decrypt_res[0]);
          setTotalPat(decrypt_res[1]);
        } else {
          setFornoresults([]);
        }
      })
      .catch(() => {
        setFornoresults([]);
      });
  };

  useEffect(() => {
    if (!selectPatList.includes("0")) {
      setPatientData(fullPatientList);
      setFornoresults(["1"]);
    }
  }, [selectPatList]);

  useEffect(() => {
    let isCancelled = false;
    const run = async () => {
      await timeout(800);
      if (!isCancelled) fetchPatients(patSearchVal);
    };
    run();
    return () => {
      isCancelled = true;
    };
  }, [patSearchVal]);

  // ─── Add / Edit Modal Handlers ────────────────────────────────────────────
  const openAddModal = () => {
    setIsEditMode(false);
    setEditId(null);
    setTitleVal("");
    setDescVal("");
    setTitleErr(false);
    setDescErr(false);
    setShowAddModal(true);
  };

  const openEditModal = (item) => {
    setIsEditMode(true);
    setEditId(item.id);
    setTitleVal(item.title);
    setDescVal(item.description);
    setTitleErr(false);
    setDescErr(false);
    setShowAddModal(true);
  };

  const closeAddModal = () => {
    setShowAddModal(false);
    setTitleVal("");
    setDescVal("");
    setTitleErr(false);
    setDescErr(false);
    setEditId(null);
    setIsEditMode(false);
  };

  const handleSave = () => {
    let err = false;
    if (!titleVal.trim()) {
      setTitleErr(true);
      err = true;
    }
    if (!descVal.trim()) {
      setDescErr(true);
      err = true;
    }
    if (err) return;

    setSaveLoading(true);
    const article = {
      title: titleVal.trim(),
      description: descVal.trim(),
      uid: provider,
      ...(isEditMode && { id: editId }),
    };
    const encrypted = Encrypt_Value(article, "vozo");

    const endpoint = isEditMode
      ? "/vozo/dietrecommendation/update"
      : "/vozo/dietrecommendation/add";

    axiosInstance
      .post(endpoint, encrypted)
      .then(() => {
        setSaveLoading(false);
        closeAddModal();
        showAlert(
          isEditMode
            ? "Diet Recommendation updated successfully"
            : "Diet Recommendation added successfully",
        );
        fetchDietList(
          searchText,
          isDateChanged ? fromdt : "",
          isDateChanged ? todt : "",
        );
      })
      .catch(() => {
        setSaveLoading(false);
        showAlert("Something went wrong. Please try again.", "error");
      });
  };

  // ─── Preview Modal ────────────────────────────────────────────────────────
  const openPreview = (item) => {
    setPreviewItem(item);
    setShowPreview(true);
  };

  // ─── Recommend Modal Handlers ─────────────────────────────────────────────
  const openRecommendModal = (item) => {
    setRecommendId(item.id);
    setSelectPatList([]);
    setPatientData([]);
    setFullPatientList([]);
    setPatSearchVal("");
    setPatErr(false);
    setShowRecommendModal(true);
    fetchPatients();
  };

  const closeRecommendModal = () => {
    setShowRecommendModal(false);
    setRecommendId(null);
    setSelectPatList([]);
    setPatientData([]);
    setPatErr(false);
  };

  const handlePatientSelectChange = (val) => {
    if (val.includes("0")) {
      setSelectPatList(["0"]);
      setPatientData([]);
      setPatSearchVal("");
    } else {
      setSelectPatList(val);
      setPatientData(fullPatientList);
    }
    setPatErr(false);
  };

  const handlePatientSearch = (val) => {
    if (!selectPatList.includes("0")) {
      setPatSearchVal(val);
      setFornoresults(["1"]);
    } else {
      setFornoresults(["2"]);
    }
  };

  const handleAssign = () => {
    if (!selectPatList || selectPatList.length === 0) {
      setPatErr(true);
      return;
    }
    setAssignLoading(true);
    const article = {
      diet_id: recommendId,
      patient_ids: selectPatList,
      uid: provider,
    };
    const encrypted = Encrypt_Value(article, "vozo");

    axiosInstance
      .post("/vozo/dietrecommendation/assign", encrypted)
      .then(() => {
        setAssignLoading(false);
        closeRecommendModal();
        showAlert("Recommendation assigned to patient successfully");
      })
      .catch(() => {
        setAssignLoading(false);
        showAlert(
          "Failed to assign recommendation. Please try again.",
          "error",
        );
      });
  };

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <>
      <SideNav />
      <div
        className={
          (navData1 === "iconopen" && "nav_right") ||
          (navData1 === "iconclose" && "nav_right1")
        }
      >
        <div
          id="demographics"
          className="appt-block-main-bill p-b-6 m-r-0 p-r-13"
        >
          <div
            className="appt-block-main schedule-comp1"
            style={{ marginTop: 4 }}
          >
            <PageWrapper>
              {/* ── Header ── */}
              <HeaderRow>
                <PageTitle>Diet Recommendation</PageTitle>
                <AddButton onClick={openAddModal}>
                  Add Diet Recommendation
                </AddButton>
              </HeaderRow>

              {/* ── Filters ── */}
              <FilterRow>
                <SearchWrapper>
                  <AiOutlineSearch />
                  <input
                    placeholder="Search Diet"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                  />
                </SearchWrapper>

                {/* <div id="rpt_pay-inp_dt">
                  <RangePicker
                    allowClear
                    getPopupContainer={(n) => n.parentNode}
                    value={[
                      moment(fromdt, "YYYY-MM-DD"),
                      moment(todt, "YYYY-MM-DD"),
                    ]}
                    format={dateFormat}
                    onChange={(v) => {
                      if (v && v[0] && v[1]) {
                        setFromdt(moment(v[0]).format("YYYY-MM-DD"));
                        setTodt(moment(v[1]).format("YYYY-MM-DD"));
                        setIsDateChanged(true);
                      } else {
                        handleResetDateFilter();
                      }
                    }}
                  />
                </div> */}
                <div
                  id="rpt_pay-inp_dt"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <span
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    From
                  </span>

                  <DatePicker
                    allowClear
                    style={{ width: "130px" }}
                    getPopupContainer={(n) => n.parentNode}
                    value={fromdt ? moment(fromdt, "YYYY-MM-DD") : null}
                    format={dateFormat}
                    onChange={(date) => {
                      if (date) {
                        setFromdt(moment(date).format("YYYY-MM-DD"));
                        setIsDateChanged(true);
                      } else {
                        handleResetDateFilter();
                      }
                    }}
                  />

                  <span
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    To
                  </span>

                  <DatePicker
                    allowClear
                    style={{ width: "130px" }}
                    getPopupContainer={(n) => n.parentNode}
                    value={todt ? moment(todt, "YYYY-MM-DD") : null}
                    format={dateFormat}
                    onChange={(date) => {
                      if (date) {
                        setTodt(moment(date).format("YYYY-MM-DD"));
                        setIsDateChanged(true);
                      } else {
                        handleResetDateFilter();
                      }
                    }}
                  />
                </div>

                <SearchButton onClick={handleSearch}>Search</SearchButton>
              </FilterRow>

              {/* ── Card Grid ── */}
              {dietList.length > 0 ? (
                <CardGrid>
                  {dietList.map((item, index) => (
                    <DietCard key={item.id || index}>
                      <CardTitle>{item.title}</CardTitle>
                      <CardDescription>{item.description}</CardDescription>
                      <CardDate>
                        {item.created_at
                          ? moment(item.created_at).format("MMM DD, YYYY")
                          : ""}
                      </CardDate>
                      <CardFooter>
                        <RecommendButton
                          onClick={() => openRecommendModal(item)}
                        >
                          Recommend to Patient
                        </RecommendButton>
                        <IconGroup>
                          <IconBtn
                            title="Preview"
                            onClick={() => openPreview(item)}
                          >
                            <AiOutlineEye />
                          </IconBtn>
                          <IconBtn
                            title="Edit"
                            onClick={() => openEditModal(item)}
                          >
                            <AiOutlineEdit />
                          </IconBtn>
                        </IconGroup>
                      </CardFooter>
                    </DietCard>
                  ))}
                </CardGrid>
              ) : (
                <EmptyWrapper>
                  <Image height="133px" width="133px" src={Emp_data_pic} />
                </EmptyWrapper>
              )}
            </PageWrapper>
          </div>
        </div>
      </div>

      {/* ══ Add / Edit Modal ══════════════════════════════════════════════════ */}
      <PreviewModalStyled
        className="client-popup-for-billing-profiles popup_centre"
        centered
        show={showAddModal}
        onHide={closeAddModal}
      >
        <Modal.Header closeButton>
          <div className="ed-doc-mod-title">
            {isEditMode
              ? "Edit Diet Recommendation"
              : "Add Diet Recommendation"}
          </div>
        </Modal.Header>
        <Modal.Body className="ed-doc-mod-body">
          <FieldWrapper>
            <ModalLabel>Title</ModalLabel>
            <ModalInput
              placeholder="Enter title"
              value={titleVal}
              onChange={(e) => {
                setTitleVal(e.target.value);
                if (e.target.value.trim()) setTitleErr(false);
              }}
            />
            {titleErr && <ErrorText>Please enter a title</ErrorText>}
          </FieldWrapper>

          <FieldWrapper>
            <ModalLabel>Description</ModalLabel>
            <ModalTextarea
              placeholder="Enter description"
              value={descVal}
              onChange={(e) => {
                setDescVal(e.target.value);
                if (e.target.value.trim()) setDescErr(false);
              }}
            />
            {descErr && <ErrorText>Please enter a description</ErrorText>}
          </FieldWrapper>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="close_active add_edit_con_form_cancel_btn btn btn-light"
            onClick={closeAddModal}
          >
            Cancel
          </button>
          <button
            className="save_active add_edit_con_form_upload_btn btn btn-primary"
            onClick={handleSave}
            disabled={saveLoading}
          >
            {saveLoading ? "Saving..." : "Save"}
          </button>
        </Modal.Footer>
      </PreviewModalStyled>

      {/* ══ Preview Modal ════════════════════════════════════════════════════ */}
      <PreviewModalStyled
        className="client-popup-for-billing-profiles popup_centre"
        centered
        show={showPreview}
        onHide={() => setShowPreview(false)}
      >
        <Modal.Header closeButton>
          <div className="ed-doc-mod-title">Preview</div>
        </Modal.Header>
        <Modal.Body className="ed-doc-mod-body">
          {previewItem && (
            <>
              <PreviewTitle>{previewItem.title}</PreviewTitle>
              <PreviewDesc>{previewItem.description}</PreviewDesc>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="close_active add_edit_con_form_cancel_btn btn btn-light"
            onClick={() => setShowPreview(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </PreviewModalStyled>

      {/* ══ Recommend to Patient Modal ════════════════════════════════════════ */}
      <Modal
        className="up-doc-modal popup_centre"
        centered
        show={showRecommendModal}
        onHide={closeRecommendModal}
      >
        <Modal.Header closeButton>
          <div className="ed-doc-mod-title">Recommend to Patients</div>
        </Modal.Header>
        <Modal.Body className="ed-doc-mod-body" id="cnst_frm-mod_bdy">
          {/* Patient Select */}
          <FieldWrapper>
            <ModalLabel>Patient</ModalLabel>
            <Select
              mode="multiple"
              placeholder="Search Patient"
              suffixIcon={<CustomSuffixIcon />}
              className="arrow-adj w-100"
              value={selectPatList}
              showSearch
              optionFilterProp="children"
              onChange={handlePatientSelectChange}
              onSearch={handlePatientSearch}
              notFoundContent={
                selectPatList.includes("0")
                  ? "You have selected Global All Patient"
                  : fornoresults.length === 0
                    ? "No Results Found"
                    : "Loading..."
              }
              style={{ width: "100%" }}
            >
              <Option disabled>Select Patient</Option>
              <Option value="0" key="0">
                Global All Patient
              </Option>
              {!selectPatList.includes("0") &&
                patientData.map((s) => (
                  <Option key={s.pid} value={s.pid} title={s.pname}>
                    {s.pname}
                  </Option>
                ))}
            </Select>
            {patErr && (
              <ErrorText>Please select at least one patient</ErrorText>
            )}
          </FieldWrapper>

          {/* Number of patients assigned */}
          {selectPatList.length > 0 && (
            <AssignedCount>
              Number of patient's assigned :{" "}
              {selectPatList.includes("0") ? totalPat : selectPatList.length}
            </AssignedCount>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="close_active add_edit_con_form_cancel_btn btn btn-light"
            onClick={closeRecommendModal}
          >
            Cancel
          </button>
          <button
            className="save_active add_edit_con_form_upload_btn btn btn-primary"
            onClick={handleAssign}
            disabled={assignLoading}
          >
            {assignLoading ? "Assigning..." : "Assign"}
          </button>
        </Modal.Footer>
      </Modal>

      {/* ══ Success Alert ════════════════════════════════════════════════════ */}
      <Modal
        className="alert-popup-message"
        show={showSuccess}
        onHide={() => setShowSuccess(false)}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          {alertMsg}
        </div>
      </Modal>

      {/* ══ Error Alert ══════════════════════════════════════════════════════ */}
      <Modal
        className="alert-popup-message"
        show={showError}
        onHide={() => setShowError(false)}
      >
        <div className="alert msg alert-danger" role="alert">
          <IoCloseSharp className="icons-bs up-d-mod-mb" />
          {alertMsg}
        </div>
      </Modal>
    </>
  );
};

export default DietRecommendation;
